import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonConfig, DwModalResult, DwButtonCommand, DwModalHandler, DwModalConfig, DwMessage, DwMessageSeverity } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { SubscriptionChangeStartResult } from '../../models/subscriptions/subscription-change-start-result.model';
import { SubscriptionChangeUIActions } from '../../models/subscriptions/subscription-change-ui-actions.enum';
import { SubscriptionChangeCompleteRequest } from '../../models/subscriptions/subscription-change-complete-request.model';
import { SubscriptionChangeActionResult } from '../../models/subscriptions/subscription-change-action.result.enum';
import { PaymentsRepositoryService } from '../../services/payments-repository.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-change-school-subscription-modal',
  templateUrl: './change-school-subscription-modal.component.html',
  styleUrls: ['./change-school-subscription-modal.component.scss']
})
export class ChangeSchoolSubscriptionModalComponent implements OnInit, DwModalHandler {

  constructor(private paymentsRespositoryService: PaymentsRepositoryService) { }
  modalConfig: DwModalConfig<SubscriptionChangeStartResult>;
  closeModal: EventEmitter<DwModalResult<any>>;

  changeStartResult: SubscriptionChangeStartResult;

  changeCompleteRequest: SubscriptionChangeCompleteRequest;
  showDowngradeNow: boolean = false;
  downgradeNow: boolean = false;

  message: DwMessage;

  ngOnInit(): void {
    this.setupModal();
  }

  setupModal() {
    this.changeStartResult = this.modalConfig.data;

    this.changeCompleteRequest = {
      SubscriptionChangeStartResult: this.changeStartResult,
      SubscriptionChangeAction: null,
      DowngradeNow: false
    }

    switch (this.changeStartResult.SubscriptionChangeUIAction) {
      case SubscriptionChangeUIActions.downgradeSubscriptionVerify:
        this.showDowngradeNow = true;

        this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmDowngrade;
        break;
      case SubscriptionChangeUIActions.updateSubscriptionNoInvoice:
        this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmUpgrade;
        break;

      break;
    }
  }

  onDowngradeNow(value) {
    this.changeCompleteRequest.DowngradeNow = value;
    // if (value) {
    //   this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmDowngradeNow;
    // } else {
    //   this.changeCompleteRequest.SubscriptionChangeAction = SubscriptionChangeActionResult.confirmDowngrade;
    // }
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    let result = new DwModalResult();
    result.cancelled = false;

    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.saveAndClose:
      case DwButtonCommand.save:
        return this.completeSubscriptionChange();

        break;
      case DwButtonCommand.cancel:
        result.closeModal = true;
        result.cancelled = true;
    }
    return of(result);
  }

  processing = false;

  completeSubscriptionChange(): Observable<DwModalResult> {
    let result = new DwModalResult();
    this.message = null; 

    if (this.changeStartResult.SubscriptionChangeUIAction == SubscriptionChangeUIActions.none) {
      result.closeModal = true;
      result.cancelled =true;

      return of (result); 
    }
    
    return this.paymentsRespositoryService.subscriptionChangeComplete(this.changeCompleteRequest)
      .pipe(map((changeResult) => {
        let result = new DwModalResult();

        if (!changeResult.Success) {
          result.cancelled = true;
          result.closeModal = false;

          this.message = {
            messageBody : changeResult.Message,
            allowClose : true,
            severity: DwMessageSeverity.error
          };
        }
        result.cancelled = false;
        result.closeModal = true;
        result.data = changeResult;

        return result;
      }));
  }

}
